export default (function (arr) { return arr[arr.length - 1]; });



//////////////////
// WEBPACK FOOTER
// ./~/@reecelucas/react-use-hotkeys/esm/helpers/tail.js
// module id = 660
// module chunks = 0